<template>
  <div id="page-user-list" class="mt-4" style="margin-left:-15px; margin-right:-15px">
    <div class="vx-card p-6">
        <span class="title-package">{{ $t('packageUpgrade.packageData')}}</span>
        <div class="flex">
          <div class="width-col h-14 flex">
            <span class="sm:flex hidden m-auto"></span>
          </div>
          <div v-for="item in packages" class="flex-1 h-auto request-button mb-4">
            <div class="component">
                <span class="text-button-request-bold">{{item.packageName}}</span>
            </div>
            <span class="text-button-request">{{item.name}}</span>
            <div class="w-full" v-if="item.id == businessPackage.id">
              <vs-button
                @click="userRegisterPackage(item.id)"
                class="button-used-package"
                >
                {{ $t('packageUpgrade.present')}}
              </vs-button>
            </div>
            <div class="w-full" v-else>
              <vs-button
                @click="userRegisterPackage(item.id)"
                color="primary"
                type="border">
                {{$t('packageUpgrade.request')}}
              </vs-button>
            </div>
          </div>
        </div>

        <div class="flex header-table">
          <div class="flex-1 h-12 flex">
            <span class="sm:flex hidden header-float mt-3">{{$t('packageUpgrade.limit')}}</span>
          </div>
          <div v-for="item in packages" class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto"></span>
          </div>
        </div>

        <div class="flex border-bottom">
          <div class="width-col h-auto flex">
              <div class="vx-row ml-0 text-inline">
                  <div class="component">
                        <span class="sm:flex hidden header-float m-auto text-button-request">{{$t('packageUpgrade.numberFolow')}}</span>
                  </div>
                  <div class="component">
                        <span class="sm:flex hidden header-float sub-title"> {{$t('packageUpgrade.theWholeAccount')}}</span>
                  </div>
              </div>
          </div>
          <div v-for="item in packages" class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto text-button-request">{{item.totalKeyword}} {{$t('packageUpgrade.keyword')}}</span>
          </div>
        </div>
        <div class="flex border-bottom">
          <div class="width-col h-12 flex">
              <div class="vx-row ml-0 text-inline ">
                  <div class="component">
                        <span class="sm:flex hidden header-float m-auto text-button-request">{{$t('packageUpgrade.dayUser')}}</span>
                  </div>
                  <div class="component">
                        <span class="sm:flex hidden header-float sub-title">{{ $t('packageUpgrade.theWholeAccount')}}</span>
                  </div>
              </div>
          </div>
          <div v-for="item in packages" class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto text-button-request">{{item.days}} {{$t('packageUpgrade.day')}}</span>
          </div>
        </div>

        <div class="flex border-bottom">
            <div class="width-col bg-grid-color-secondary h-12 flex">
               <div class="width-col h-12 flex">
                    <div class="vx-row ml-0 text-inline ">
                        <div class="component">
                            <span class="sm:flex hidden header-float">{{$t('packageUpgrade.limitData')}}</span>
                        </div>
                        <div class="component">
                                <span class="sm:flex hidden header-float sub-title">{{ $t('packageUpgrade.inAMonth')}}</span>
                        </div>
                    </div>
                </div>
            </div>
          <div v-for="item in packages" class="flex-1 bg-grid-color-secondary h-12 flex">
            <span class="sm:flex hidden m-auto text-button-request">{{item.totalData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") }}</span>
          </div>
        </div>

        <div class="flex border-bottom">
          <div class="width-col h-12 flex">
            <div class="width-col h-12 flex">
                <div class="width-col h-12 flex">
                    <div class="vx-row ml-0 text-inline ">
                        <div class="component">
                            <span class="sm:flex hidden header-float">{{$t('packageUpgrade.createAcc')}}</span>
                        </div>
                        <div class="component">
                            <span class="sm:flex hidden header-float sub-title">{{ $t('packageUpgrade.theWholeAccount')}}</span>
                        </div>
                    </div>
                </div>
            </div>
          </div>
          <div v-for="item in packages" class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto text-button-request"><span v-if="item.totalSubAccount < 10">0</span> {{item.totalSubAccount}} {{ $t('packageUpgrade.account')}}</span>
          </div>
        </div>

        <!-- <div class="flex border-bottom">
          <div class="width-col bg-grid-color-secondary h-12 flex">
                <div class="width-col h-12 flex">
                    <div class="vx-row ml-0 text-inline ">
                        <div class="component">
                            <span class="sm:flex hidden header-float">{{$t('packageUpgrade.cost')}}</span>
                        </div>
                        <div class="component">
                            <span class="sm:flex hidden header-float sub-title">{{ $t('packageUpgrade.inAMonth')}}</span>
                        </div>
                    </div>
                </div>
          </div> -->
          <!-- <div v-for="item in packages" class="flex-1 bg-grid-color-secondary h-12 flex">
              <span class="sm:flex hidden m-auto text-button-request">{{item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}} {{$t('packageUpgrade.vnd')}}</span>
          </div> -->
        </div>

        <div class="flex header-table">
          <div class="width-col h-12 flex">
            <span class="sm:flex hidden header-float mt-3">{{$t('packageUpgrade.feature')}}</span>
          </div>
          <div v-for="item in packages" class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto"></span>
          </div>
        </div>

        <div v-for="(p, i) in allPermissions">
          <div class="flex border-bottom">
            <div class="width-col h-12 flex">
              <span class="sm:flex hidden text-button-request m-auto header-float">{{p.functionAlias}}</span>
            </div>
            <div v-for="item in packages" class="flex-1 h-12 flex">
              <span class="sm:flex hidden m-auto">
                <feather-icon v-if="item[p.functionAlias.toString()]" icon="CheckIcon" style="width: 1.2rem;" class="color-checked"></feather-icon>
              </span>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<style>
  .bg-grid-color-secondary {
    background-color: #dae1e729;
  }

  [dir] .m-auto {
    color: #2a3035;
  }

  .header-float {
    margin-left: 10px !important;
  }

  .vx-card__title > h4 {
    font-weight: bold;
  }
</style>

<script>
  import moment from "moment";

  export default {
    components: {},
    data() {
        return {
            packageString: '',
            packages: [],
            allPermissions: [],
            usingPackage: {},
            businessPackage: {},
        }
    },
    created() {
      this.initScreen();
      this.$eventBus.$on('i18n', (event) =>{
          this.initScreen();
      })
    },
    watch: {
      '$store.state.windowWidth'(val) {
        if (val <= 1024) {
          this.maxPageNumbers = 5;
        } else {
          this.maxPageNumbers = 7;
        }

        if (val > 1024) {
          this.gridApi.sizeColumnsToFit();
        }
      },
      '$store.state.reduceButton'() {
        setTimeout(() => {
          this.gridApi.sizeColumnsToFit();
        }, 650);
      },
      '$store.state.isUpdateUser'(val) {
        if (val) {
          this.initScreen();
          this.$store.commit('UPDATE_USER_SUCCESS', false);
        }
      },
    },
    computed: {
      totalPages() {
        if (this.gridApi) return this.gridApi.paginationGetTotalPages();
        else return 0
      },
      currentPage: {
        get() {
          if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
          else return 1
        },
        set(val) {
          this.gridApi.paginationGoToPage(val - 1)
        }
      }
    },
    methods: {
        canceNotify: function(){
            this.activeNotify = false;
        },
        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
            this.maxPageNumbers = 5;
            } else {
            this.maxPageNumbers = 7;
            }

            if (this.$store.state.windowWidth > 1024) {
            this.gridApi.sizeColumnsToFit();
            }
        },
        checkRegisterPackage: function(){
            return new Promise((resolve, reject) => {
            this.$business.get('user-package/user-all-register-package').then((res) => {
                const result = res.data.filter(el => el.status == 0);
                if(result.length > 0){
                return this.$vs.dialog({
                    type: 'confirm',
                    color: 'primary',
                    title: this.$t('packageUpgrade.titlePackage'),
                    accept: this.backToPackageManage,
                    text: `${this.$t('packageUpgrade.text1')} ` + ` ${result[0].businessPackage.name} ` + ` ${this.$t('packageUpgrade.text2')}` ,
                    acceptText: this.$t('packageUpgrade.acceptText'),
                    cancelText: this.$t('packageUpgrade.cancelText'),
                })
                }
                resolve();
            })
            })
        },
        async initScreen() {
            this.usingPackage = await this.getUsingPackage(this);
            this.businessPackage = this.usingPackage.businessPackage;
            if (new Date(this.usingPackage.expiredDate).getTime() > new Date()) {
            this.packageString = this.usingPackage.businessPackage.name + ` ${this.$t('packageUpgrade.text3')} ` + moment(this.usingPackage.expiredDate).format("DD/MM/YYYY") + ".";
            } else {
            this.packageString = this.usingPackage.businessPackage.name + ` ${this.$t('packageUpgrade.text4')} `
            }
            this.packages = await this.getPackage(this);
            this.packages = this.packages.filter(item => item.allowUserRegister);
            this.allPermissions = await this.getAllPermission(this);
            this.allPermissions.forEach(permission => {
            let functionAlias = permission.functionAlias;
            this.packages.forEach(p => {
                p[functionAlias.toString()] = "";
                let permissions = p.permissions;
                if (permissions && permissions.length > 0) {
                let per = permissions.find(per => per.id == permission.id);
                if (per) {
                    p[functionAlias.toString()] = true;
                } else {
                    p[functionAlias.toString()] = false;
                }
                } else {
                p[functionAlias.toString()] = false;
                }
            })
            });
            this.allPermissions = this.allPermissions.sort(function(a,b){
            return parseInt(a.metadata) - parseInt(b.metadata);
            });
        },
        getPackage(that) {
            return new Promise(function (resolve, reject) {
                that.$business.get('/business-package/all').then((res) => {
                    res.data.map(el => {
                        if (el.name.includes('Gói khởi động')) el.packageName = 'STARTER'
                        if (el.name.includes('Gói cơ bản')) el.packageName = 'BASIC'
                        if (el.name.includes('Gói nâng cao')) el.packageName = 'PRO'
                        if (el.name.includes('Gói chuyên nghiệp')) el.packageName = 'ADVANCE'
                        if (el.name.includes('Gói cao cấp')) el.packageName = 'PREMIUM'
                        
                    })
                resolve(res.data);
                }).catch((err) => {
                reject(err);
                });
            }
            );
        },
        getAllPermission(that) {
            return new Promise(function (resolve, reject) {
                that.$business.post('/permission/all').then((res) => {
                resolve(res.data);
                }).catch((err) => {
                reject(err);
                });
            }
            );
        },
        getUsingPackage(that) {
            return new Promise(function (resolve, reject) {
                that.$business.post('/user-package/using-package').then((res) => {
                resolve(res.data);
                }).catch((err) => {
                reject(err);
                });
            }
            );
        },
        backToPackageManage(){
            this.$router.push('/user/package/manage').catch(() => {});
        },
        userRegisterPackage(id) {
            this.checkRegisterPackage().then(() => {
            this.$business.post('/user-package/register', {packageId: id,paymentPeriodType:3,paymentType:1}).then((res) => {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'primary',
                    title: this.$t('packageUpgrade.titleSuccess'),
                    accept: this.backToPackageManage,
                    text: this.$t('packageUpgrade.text5'),
                    acceptText: this.$t('packageUpgrade.acceptText'),
                    cancelText: this.$t('packageUpgrade.cancelText'),
                })
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                text: err.response.message || err.response.error_description || err.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
                });
            });
            });
        }
    },
    mounted(){
        document.getElementsByClassName('vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null')[0].style.display = 'none'
        document.getElementsByClassName('vs-popup--header')[0].style.display = 'none'
    }
  }
</script>
<style scoped>
.minus-top{
  margin-top: -24px;
}
.request-button {
    text-align: center;
}
.text-button-request {
    font-size: 14px;
    color: #78738a !important; 
}
.text-button-request-bold {
    font: 16px;
    font-weight: bold;
    color: #5E5873;
}
.header-table {
    color: #2F80ED;
    background: rgba(47, 128, 237, 0.12);
    font-weight: bold;
}
.border-bottom {
    border-bottom: 1px solid #D8D6DE;
}
.sub-title {
    color: #78738a;
    font-size: 12px;
}
.width-col {
    width: 280px;
}
.text-inline {
    display: inline;
}
.title-package {
    color: #252733;
    font-size: 14px;
    font-weight: bold;
}
.color-checked {
    color: #2F80ED;
}
.button-used-package {
    background: repeating-linear-gradient( 20deg
 , rgb(47, 128, 237), transparent 90px) !important;
    color: white;
}
@media (max-width: 1366px){
#page-user-list{
  margin-left: -13px;
}
}
</style>
